import { render, staticRenderFns } from "./Duel_Header_UserIconsRow.vue?vue&type=template&id=5b57fa8c&"
import script from "./Duel_Header_UserIconsRow.vue?vue&type=script&lang=js&"
export * from "./Duel_Header_UserIconsRow.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Header_UserIconsRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports